// Mobile approvals inbox. Approve/Decline sit on the card so you don't have
// to open anything first.

import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";

import NotAuthorized from "modules/5_view_helpers/mobile/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";
import { getApprovals } from "../actions";
import { Block, BlockTitle, Button, List, ListItem, Page } from "framework7-react";
import AppNavbar from "modules/1_layout/mobile/AppNavbar";
import ApprovalStepButton from "../steps/ApprovalStepButton";

function mapStateToProps(state) {
  return {
    current_user: state.current_user,
    approvals: state.approvals,
  };
}

const ApprovalsIndex = (props) => {
  useEffect(() => {
    props.getApprovals();
  }, []);

  const { approvals } = props;
  const readRole = HasRole({ resource_type: "Approval", name: ["read", "moderator"] }, true);

  const list = _.values(approvals);
  const mine = _.filter(list, (a) => a.your_turn);
  const waiting = _.filter(list, (a) => !a.your_turn && !a.approved && !a.rejected);

  if (!readRole) return <NotAuthorized />;

  return (
    <Page>
      <AppNavbar title="Approvals" />
      {_.isNotEmpty(mine) && <ApprovalsList approvals={mine} title="Waiting on you" />}
      {_.isNotEmpty(waiting) && <ApprovalsList approvals={waiting} title="Waiting on others" />}
      {_.isEmpty(mine) && _.isEmpty(waiting) && <BlockTitle>Nothing waiting</BlockTitle>}
    </Page>
  );
};

export default connect(mapStateToProps, { getApprovals })(ApprovalsIndex);

const ApprovalsList = ({ approvals, title }) => {
  return (
    <Fragment>
      <BlockTitle>{title}</BlockTitle>
      {_.map(approvals, (approval) => {
        const steps = _.sortBy(approval.steps || [], "step_number");
        const actionable = _.find(steps, { id: approval.actionable_step_id });
        const status = approval.your_turn
          ? "Your turn"
          : approval.waiting_on
          ? `Waiting on ${approval.waiting_on}`
          : "Pending";

        return (
          <Block key={approval.id} strong inset>
            <p>
              <b>{approval.title || `Approval #${approval.id}`}</b>
            </p>
            <p>
              {status}
              {approval.due_date ? ` · Due ${moment(approval.due_date).format("DD/MM/YYYY")}` : ""}
            </p>
            {approval.content && <p>{approval.content}</p>}
            {approval.your_turn && actionable && (
              <div>
                <ApprovalStepButton mobile inline approval={approval} approval_step={actionable} approval_step_id={actionable.id} />
              </div>
            )}
            {approval.report_link && (
              <p>
                <Button fill external target="_blank" href={approval.report_link}>
                  View Report
                </Button>
              </p>
            )}
            <List inset>
              {_.map(steps, (step) => (
                <ListItem key={step.id} title={`Step ${step.step_number} — ${step.approver || "—"}`} after={step.approved ? "Approved" : "Pending"} />
              ))}
            </List>
          </Block>
        );
      })}
    </Fragment>
  );
};
